import React from 'react';
import { motion } from 'framer-motion';

const GoldButton = ({ 
  children, 
  href, 
  onClick,
  variant = 'primary',
  className = '',
  shimmer = false,
  dataAnalytics = '',
  ...props 
}) => {
  const baseClasses = `
    px-8 py-4 rounded-full font-bold text-lg
    transition-all duration-300
    inline-flex items-center gap-2
    focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-dark-navy
    ${shimmer ? 'animate-shimmer' : ''}
  `;

  const variants = {
    primary: `
      bg-gradient-to-r from-[#D4AF37] via-[#f5e8b8] to-[#D4AF37]
      text-dark-navy
      hover:shadow-lg hover:shadow-gold/50
      hover:scale-105
      bg-[length:200%_auto]
    `,
    outline: `
      border-2 border-gold
      text-gold
      hover:bg-gold hover:text-dark-navy
      hover:scale-105
    `,
  };

  const buttonContent = (
    <motion.button
      className={`${baseClasses} ${variants[variant]} ${className}`}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      data-analytics={dataAnalytics}
      {...props}
    >
      {children}
    </motion.button>
  );

  if (href) {
    return (
      <a 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        data-analytics={dataAnalytics}
        className="inline-block"
      >
        {buttonContent}
      </a>
    );
  }

  return buttonContent;
};

export default GoldButton;

